import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';
import { removeFromArrayByVal, getObjIndex } from '../functions'

@Component({
  selector: 'app-multiselect',
  templateUrl: './multiselect.component.html',
  styleUrls: ['./multiselect.component.css'],
})
export class MultiselectComponent implements OnInit {

	@Input() selectables = [];
	@Output('selectedChange') selectedChange = new EventEmitter<any>();
	@Input() selected = [];
	active: boolean = false;
	searchQuery: string;

	constructor() {
		document.addEventListener('click', this.clickAway.bind(this)); // lets us trigger clickAway() on clicks in the browser window
	}

	ngOnInit() {
		this.subtractSelected();
		this.selectedChange.emit( this.selected );
	}

	// add a selectable to the selected array
	select( item: any ) {
		if ( !Array.isArray(this.selected) ) { // convert to array if necessary, or else push() will throw error
			this.selected = [];
		}
		this.selected.push( item );
		removeFromArrayByVal( this.selectables, item );
		this.selectedChange.emit( this.selected );
	}

	// remove a selectable from the selected array
	deselect( item: any ) {
		removeFromArrayByVal( this.selected, item );
		this.selectables.push( item );
		this.selectedChange.emit( this.selected );
	}

	// open list of selectables
	activate() {
		this.active = true;
	}

	// close list of selectables
	deactivate() {
		this.searchQuery = '';
		this.search();
		this.active = false;
	}

	// close list of selectables when clicking outside component
	clickAway(event) {
		if ( !event.target.closest(".multiselect") ) { 
	        this.deactivate();
	    }
	}

	// subtract selected from selectables
	subtractSelected() {
		if (this.selectables) {
			let selectables = this.selectables.filter(
				user => getObjIndex(user.id, this.selected) === -1
			);
			this.selectables = selectables;
		}
	}

	// search selectables. searches in all properties of a selectable
	search() {

		// loop through all selectables and see if any of their property values match the searchQuery (this.searchQuery)
		if ( this.selectables && this.selectables.length ) {

			for (var i = 0; i < this.selectables.length; ++i) {

				for ( var prop in this.selectables[i] ) {

					if ( this.selectables[i].hasOwnProperty(prop) && typeof this.selectables[i][prop] == 'string' ) {

						if ( this.selectables[i][prop].indexOf(this.searchQuery) !== -1 ) {

							this.selectables[i]['hidden'] = false;
							break;

						} else {

							this.selectables[i]['hidden'] = true;

						}

					}

				}

			}

		}

	}

}



// WEBPACK FOOTER //
// ./src/app/multiselect/multiselect.component.ts